import React from 'react';
import ErrorListItem, {EmptyContainer} from './ErrorListItem';
import {ListViewForm} from './ViewForm';
import i18n from 'i18next';

export default ({errors, archivePath, fetching, onGetErrors, onCleanErrors, permissions}) => {
  if (!permissions) {
    return null;
  }
  let actions = [];
  if (permissions.reset) {
    actions.push({
      name: i18n.t('clients:Clear errors'),
      onClick: onCleanErrors,
    });
  }
  if (permissions.view) {
    actions.push({
      name: i18n.t('clients:Request current errors'),
      onClick: onGetErrors,
    })
  }
  return (
    <ListViewForm
      title={i18n.t('clients:DTC errors')}
      actions={actions}
      data={errors}
      ItemContainer={ErrorListItem}
      EmptyContainer={() => <EmptyContainer msg={i18n.t('clients:No DTC errors')} />}
      more={permissions.archive && {
        name: i18n.t('clients:Show errors archive'),
        href: archivePath
      }}
      fetching={fetching}
    />
  )
}
